import React, { Component } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import 'moment/locale/en-gb';
import './styles.scss';

class DatePickerDob2 extends Component {
  render() {
    const { name, meta, label, labelSize, messageType, goTab01, simple } = this.props;
    const size = labelSize || 2;
    const componentSize = size;
    if (simple) {
      return (
        <div
          className={meta && meta.error && meta.touched}
        >
          <MaskedInput
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            placeholder="dd/mm/yyyy"
            className="form-control"
            {...this.props.input}
          />
          {meta && meta.touched && meta.error && !messageType && (
            <div>
              <span className="dob-input-error">{meta.error}</span>
            </div>
          )}
          {meta && meta.touched && meta.error && messageType === 'Alert' && (
            <div style={{ padding: '10px 0px 25px' }}>
              <span className="dob-input-error">
                Date of Birth is incorrect please{' '}
                <span onClick={goTab01} className="edit-link-dob">
                  edit
                </span>{' '}
                to get a valid quote.
              </span>
            </div>
          )}
        </div>
      );
    }

    return (
      <FormGroup
        controlId={name || label}
        className={meta && meta.error && meta.touched}
      >
        <Col componentClass={ControlLabel} sm={labelSize}>
          {label} &nbsp;
        </Col>
        <Col sm={componentSize || 8 - size}>
          <MaskedInput
            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
            placeholder="dd/mm/yyyy"
            className="form-control"
            {...this.props.input}
          />
          {meta && meta.touched && meta.error && !messageType && (
            <div>
              <span className="dob-input-error">{meta.error}</span>
            </div>
          )}
          {meta && meta.touched && meta.error && messageType === 'Alert' && (
            <div style={{ padding: '10px 0px 25px' }}>
              <span className="dob-input-error">
                Date of Birth is incorrect please{' '}
                <span onClick={goTab01} className="edit-link-dob">
                  edit
                </span>{' '}
                to get a valid quote.
              </span>
            </div>
          )}
        </Col>
      </FormGroup>
    );
  }
}

export default DatePickerDob2;
